'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.707.251a1.12 1.12 0 0 0-1.414 0L9.678 1.565a1.12 1.12 0 0 1-.885.237l-2.055-.33a1.12 1.12 0 0 0-1.225.707l-.741 1.945a1.12 1.12 0 0 1-.648.648l-1.945.741c-.496.19-.791.7-.707 1.225l.33 2.055a1.12 1.12 0 0 1-.237.885L.251 11.293a1.12 1.12 0 0 0 0 1.414l1.314 1.615c.201.248.288.57.237.885l-.33 2.055a1.12 1.12 0 0 0 .707 1.225l1.945.741c.298.114.534.35.648.648l.741 1.945c.19.496.7.791 1.225.707l2.055-.33c.316-.05.637.036.885.237l1.615 1.314a1.12 1.12 0 0 0 1.414 0l1.615-1.314a1.12 1.12 0 0 1 .885-.237l2.055.33a1.12 1.12 0 0 0 1.225-.707l.741-1.945a1.12 1.12 0 0 1 .648-.648l1.945-.741c.496-.19.791-.7.707-1.225l-.33-2.055a1.12 1.12 0 0 1 .237-.885l1.314-1.615a1.12 1.12 0 0 0 0-1.414l-1.314-1.615a1.12 1.12 0 0 1-.237-.885l.33-2.055a1.12 1.12 0 0 0-.707-1.225l-1.945-.741a1.12 1.12 0 0 1-.648-.648l-.741-1.945a1.12 1.12 0 0 0-1.225-.707l-2.055.33a1.12 1.12 0 0 1-.885-.237L12.707.251ZM9.818 17.455 5.455 13.09l1.538-1.538 2.825 2.814 7.19-7.189 1.538 1.55-8.728 8.727Z",
    fill: "currentColor"
  }));
});
var CheckDecagram = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.CheckDecagram = CheckDecagram;